import React, { lazy } from 'react';
import { getEsKey } from 'globalutils/adminUtils';
import { useTranslation } from 'react-i18next';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Label = lazy(() => import(`../../Label/${layout}`));

const Message = ({ message, type, MessageContainer, noTrim = false, className = '' }) => {
  const { i18n } = useTranslation();
  return (
    <MessageContainer type={type}>
      <Label className={className}>{message ? noTrim ? message : i18n.t(getEsKey(message.trim())) : message}</Label>
    </MessageContainer>
  );
};

export default Message;
